module.exports = {"snackbar_last_news":{"button_read_more":["Lire la suite","Read more"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/News/translations/translations_snackbar_last_news.json
// module id = 1245
// module chunks = 0